import { APIPath } from '../constants';
import { CRUDService } from './crud.ts';

class Customers extends CRUDService {
  constructor() {
    super(APIPath.customers);
  }
}

const CustomersService = new Customers();
Object.freeze(CustomersService);
export { CustomersService };
